import { FabricCanvas } from '@/fabric';

export class FabricCanvasAugmented extends FabricCanvas {}

export let activeFabricCanvas: FabricCanvasAugmented;

export function setActiveFabricCanvas (canvas: FabricCanvasAugmented): void {
  activeFabricCanvas = canvas;
}
